import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import {
	IdHideEmailConfirmModal,
	IdShowEmailConfirmModal,
} from '../../constants';

export const modalStyle = css`
	overflow: auto;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	content-visibility: initial;
	html:has(#${IdHideEmailConfirmModal}):not(:has(#${IdShowEmailConfirmModal}))
		& {
		display: none;
	}
`;

export const HiddenDiv = styled.div`
	display: none;
`;
